import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Paginator } from 'primereact/paginator';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import Loader from '../../components/Loader'; 
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';

const Roles = () => {
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [roles, setRoles] = useState([]);
    const [pagination, setPagination] = useState({});
    const [apiData, setApiData] = useState({
        search: '',
        daterange: '',
        page: 1,
    });

    useEffect(() => {
        getRoleData();
    }, [apiData.page]);

    const getRoleData = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: 'GET',
                url: 'roles',
                params: {
                    search: apiData.search,
                    daterange: apiData.daterange,
                    page: apiData.page,
                },
            });
            const data = response.data;
            if (data.status) {
                setRoles(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
            console.error(error);
        }
    };

    const handlePageChange = (event) => {
        setApiData((prev) => ({ ...prev, page: event.page + 1 }));
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: 'DELETE',
                url: `roles/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getRoleData();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to change the status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: 'POST',
                url: `roles/status/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getRoleData();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: null,
            page: 1,
        });
        getRoleData();
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Roles</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">
                                    Home
                                </Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Roles</li>
                        </ul>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/roles/create" className="btn btn-base btn-sm">
                            Add New Role
                        </Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-users-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                    placeholder={("Search role..")} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button
                                                type="button"
                                                onClick={getRoleData}
                                                className="btn btn-sm btn-base mx-1"
                                            >
                                                Filter
                                            </button>
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{('clear')}</button>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Created Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600 fs-6">
                                        {roles.map((role, index) => (
                                            <tr key={index}>
                                                <td>{role.name}</td>
                                                <td>
                                                    <button
                                                        onClick={() => updateStatus(role.id)}
                                                        className="p-0 btn btn-transparent"
                                                    >
                                                        <span
                                                            className={`badge ${
                                                                role.status === 1
                                                                    ? 'badge-light-success'
                                                                    : 'badge-light-danger'
                                                            }`}
                                                        >
                                                            {role.status === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </button>
                                                </td>
                                                <td>{role.created_at}</td>
                                                <td>
                                                    <select onChange={()=> updateStatus(role.id)} value={role.status} className="form-select w-100px p-2 fs-6" >
                                                            <option value="1">Active</option>
                                                            <option value="0">In Active</option>
                                                    </select>
                                                    <Link
                                                        to={`/roles/create/${role.id}`}
                                                        className="btn btn-sm h-35px btn-light-primary"
                                                    >
                                                        <i className="bi bi-pencil-fill"></i>
                                                    </Link>
                                                    <button
                                                        onClick={() => delData(role.id)}
                                                        className="btn btn-sm btn-light-primary d-inline"
                                                    >
                                                        <i className="bi bi-trash-fill"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {isLoader && <Loader text="Loading" size={30} className="text-center" />}
                                {pagination.total_pages > 1 && (
                                    <Paginator
                                        first={(apiData.page - 1) * pagination.per_page}
                                        rows={pagination.per_page}
                                        totalRecords={pagination.total_records}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Roles;